module.exports = __webpack_public_path__ + "img/MenuIcon.b835d05c.svg";